import { render, staticRenderFns } from "./CaseBetalingInvoices.vue?vue&type=template&id=3a8e653f&"
import script from "./CaseBetalingInvoices.vue?vue&type=script&lang=js&"
export * from "./CaseBetalingInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports